<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <h2>{{ labelService.getLabel(newCompanyPanelTitle) }}</h2>
    <form [formGroup]="clientForm" class="client-form">
      <div class="patient-row">
        <mat-slide-toggle formControlName="is_patient">
          {{
            labelService.getLabel(
              "Vuoi associare questo cliente a un paziente?"
            )
          }}</mat-slide-toggle
        >

        @if (clientForm.get("is_patient")?.value) {
          <div class="patient-selector">
            <div class="selected-patient">
              <input
                [(ngModel)]="patientSearchText"
                (ngModelChange)="filterPatients($event)"
                (click)="onInputClick($event)"
                [placeholder]="labelService.getLabel('seleziona paziente')"
                class="patient-input"
                [ngModelOptions]="{ standalone: true }"
              />
              <mat-icon (click)="togglePatientsList()">{{
                showPatientsList ? "expand_less" : "expand_more"
              }}</mat-icon>
            </div>
            @if (showPatientsList) {
              <div class="patients-list">
                <div class="patients-scroll">
                  @for (patient of filteredPatients; track patient) {
                    <div
                      class="patient-item"
                      (click)="selectPatient(patient)"
                      [class.selected]="selectedPatient?.id === patient.id"
                    >
                      {{ patient.first_name }} {{ patient.last_name }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>

      <div class="form-columns-container">
        <div class="form-column">
          <div class="row-single">
            <mat-form-field>
              <mat-label>{{ labelService.getLabel("company_name") }}</mat-label>
              <input matInput formControlName="company_name" />
            </mat-form-field>
          </div>

          <div class="row-flex">
            <mat-form-field>
              <mat-label>{{ labelService.getLabel("tax_code") }}</mat-label>
              <input
                matInput
                formControlName="tax_code"
                placeholder="Es. 01234567890"
                matTooltip="Generalmente consiste nella partita IVA senza il prefisso 'IT'"
                matTooltipPosition="below"
                minlength="11"
                maxlength="16"
              />
            </mat-form-field>

            <mat-form-field
              [ngClass]="{
                'invalid-vat':
                  clientForm.get('vat_number')?.invalid &&
                  clientForm.get('vat_number')?.touched,
              }"
            >
              <mat-label>{{ labelService.getLabel("vat_number") }}</mat-label>
              <input
                matInput
                formControlName="vat_number"
                placeholder="Es. IT01234567890"
                maxlength="13"
              />
            </mat-form-field>
          </div>

          <div class="row-flex-email">
            <mat-form-field class="email">
              <mat-label>{{ labelService.getLabel("email") }}</mat-label>
              <input matInput formControlName="email" type="email" />
            </mat-form-field>
            <mat-form-field class="unique-code">
              <mat-label>{{
                labelService.getLabel("Codice Destinatario")
              }}</mat-label>
              <input
                matInput
                maxlength="7"
                minlength="7"
                [placeholder]="'Es. 0000000'"
                formControlName="unique_code"
                matTooltip="Se non conosci il codice destinatario inserisci 0000000"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="form-column">
          <div class="row-flex-address">
            <mat-form-field class="address">
              <mat-label>{{ labelService.getLabel("Indirizzo") }}</mat-label>
              <input matInput formControlName="street_address" />
            </mat-form-field>

            <mat-form-field class="street-number">
              <mat-label>{{
                labelService.getLabel("street_number")
              }}</mat-label>
              <input matInput formControlName="street_number" />
            </mat-form-field>
          </div>

          <div class="row-flex">
            <mat-form-field>
              <mat-label>{{ labelService.getLabel("city") }}</mat-label>
              <input matInput formControlName="city" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{ labelService.getLabel("province") }}</mat-label>
              <input
                matInput
                formControlName="province"
                placeholder="Es. MI"
                maxlength="2"
              />
            </mat-form-field>
          </div>

          <div class="row-flex">
            <mat-form-field>
              <mat-label>{{ labelService.getLabel("CAP") }}</mat-label>
              <input matInput formControlName="zip_code" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{ labelService.getLabel("country") }}</mat-label>
              <mat-select formControlName="country">
                <input
                  matInput
                  (keyup)="filterCountries($event)"
                  placeholder="Cerca paese..."
                  #searchInput
                />
                @for (country of filteredCountries; track country) {
                  <mat-option [value]="country.name">
                    {{ country.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <div class="panel-buttons">
      <button class="button-white" mat-stroked-button (click)="onCancel()">
        {{ labelService.getLabel("cancel") }}
      </button>
      <button
        class="button-white"
        mat-raised-button
        (click)="onConfirm()"
        [disabled]="clientForm.invalid"
      >
        {{ labelService.getLabel("confirm") }}
      </button>
    </div>
  </div>
</div>
